import { render, staticRenderFns } from "./addDescDialog.vue?vue&type=template&id=06019aea&"
import script from "./addDescDialog.vue?vue&type=script&lang=js&"
export * from "./addDescDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports